import React from 'react';
import {GridLoader} from 'react-spinners';

class progress extends React.Component {
	render () {
		return (
			<div id="progress_wrapper">
				<GridLoader
					size={15}
					margin={"10px"}
					color={'#1996e1'}
				/>
			</div>
		);
	}
}
export default progress;



// WEBPACK FOOTER //
// ./src/common/containers/progress.js